// extracted by mini-css-extract-plugin
export var fileExt = "_s7-8";
export var fileIcon = "_s7-6";
export var fileLink = "_s7-5";
export var fileName = "_s7-7";
export var image = "_s7-1";
export var imageError = "_s7-3";
export var imageErrorIcon = "_s7-4";
export var imageLink = "_s7-0";
export var imageLoaded = "_s7-2";